import styled from 'styled-components'
export const ProgressWrapper = styled.div`
  font-size: 12px;
  --bar-color: #38b000;
  --body-color: #222;
  --text-color: white;
  --bar-wrap-back-color: white;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: min(100vh, 80px);
  margin: 0 auto;
  margin-bottom: 10px;

  .status-info {
    display: flex;
    flex-direction: column;
  }

  .title {
    padding: 0;
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    color: var(--text-color);
    font-size: 12px;
  }

  .bar-wrap {
    padding: 6px;
    margin-top: 6px;
    border-radius: 100px;
    background-color: var(--bar-wrap-back-color);
    text-align: center;
  }

  .bar {
    width: ${({ percentage }) => percentage}%;
    height: 15px;
    transition: width 0.15s ease-out;
    background-color: var(--bar-color);
    border-radius: 100px;
    box-shadow: inset -1px -1px 10px rgba(0, 0, 0, 0.5);
    font-size: 12px;
    color: black;
  }

  .percentage {
    align-self: center;
    margin: 10px 0 25px;
    font-family: 'Montserrat', sans-serif;
    font-size: clamp(1.8rem, 3.5vw, 2.6rem);
    color: var(--text-color);
  }

  .line {
    margin: 0;
    font-size: clamp(1.4rem, 2.5vw, 1.8rem);
    color: var(--text-color);
  }

  .number {
    margin-left: 8px;
    font-family: 'Montserrat', sans-serif;
    font-size: clamp(1.8rem, 3vw, 2.2rem);
  }

  .btn-wrap {
    align-self: center;
    height: 0px;
  }

  .btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: min(15vw, 70px);
    height: min(15vw, 70px);
    border: 3px solid var(--text-color);
    margin: 1rem;
    font-family: 'Fira Sans', sans-serif;
    font-size: 4.8rem;
    transition:
      background 0.15s,
      color 0.15s;
    border-radius: 50%;
    background-color: var(--text-color);
    color: var(--body-color);
  }

  .btn:active {
    background-color: var(--body-color);
    color: var(--text-color);
  }

  .percentagenumber {
    position: absolute;
    left: 46%;
  }
`
